import Vue from 'vue'
import Router from 'vue-router'
import { resolve } from 'url';

Vue.use(Router)
export default new Router({
  mode:'history',
  routes: [
    // {
    //   path:'/',
    //   redirect:{name:'jump'},
    // },
    {
      path:'/',
      redirect:{name:'Index'},
    },
   {
        path: '/Index',
        name: 'Index',
        component:resolve => require(['@/view/content/Index'], resolve),
      },
    {
        path: '/preview',
        name: 'preview',
        component:resolve => require(['@/view/content/preview'], resolve),
       
    },
    {
      path: '/jump',
      name: 'jump',
      component:resolve => require(['@/view/content/jump'], resolve),
     
  },
    { // 查看专业课学分
        path: '/CheckCredit',
        name: 'CheckCredit',
        component:resolve => require(['@/view/credit/CheckCredit'], resolve),
       
    },
    { // 查看公需课学分
        path: '/GXKCheckCredit',
        name: 'GXKCheckCredit',
        component:resolve => require(['@/view/credit/GXKCheckCredit'], resolve),
       
    },
    {
      path: '/RecognitionView',
      name: 'RecognitionView',
      component:resolve => require(['@/view/user/RecognitionView'], resolve),
    },
    
    
    {
        path: '/PrintGXK',
        name: 'PrintGXK',
        component:resolve => require(['@/components/PrintGXK'], resolve),
           
    },
    {
      path: '/PrintView',
      name: 'PrintView',
      component:resolve => require(['@/components/PrintView'], resolve),
    },
    {
      path: '/NoticeDetail/:id',
      name: 'NoticeDetail',
      component:resolve => require(['@/view/content/NoticeDetail'], resolve),
    },
    { 
        path: '/CheckCredit/:id',
        name: 'CheckCredit',
        component:resolve => require(['@/view/user/CheckCredit'], resolve),
      },
{
  path: '/Enroll',
  name: 'Enroll',
  component:resolve => require(['@/view/enroll/Enroll'], resolve),
  redirect: {name:'EnrollView'},
  children: [
    {
      path: 'EnrollView',
      name: 'EnrollView',
      component:resolve => require(['@/view/enroll/EnrollView'], resolve),
    },
    {
      path: 'EnrollType',
      name: 'EnrollType',
      component:resolve => require(['@/view/enroll/EnrollType'], resolve),
    },
    
    {
      path: 'EnrollCourse',
      name: 'EnrollCourse',
      component:resolve => require(['@/view/enroll/EnrollCourse'], resolve),
    },
    // {
    //   path: 'EnrollRegister',
    //   name: 'EnrollRegister',
    //   component:resolve => require(['@/view/enroll/EnrollRegister'], resolve),
    // },
    {
      path: 'EnrollInvoice',
      name: 'EnrollInvoice',
      component:resolve => require(['@/view/enroll/EnrollInvoice'], resolve),
    },
    // {
    //   path: 'EnrollMessage',
    //   name: 'EnrollMessage',
    //   component:resolve => require(['@/view/enroll/EnrollMessage'], resolve),
    // },
    {
      path: 'EnrollPay',
      name: 'EnrollPay',
      component:resolve => require(['@/view/enroll/EnrollPay'], resolve),
    },
    {
      path: 'EnrollFinish',
      name: 'EnrollFinish',
      component:resolve => require(['@/view/enroll/EnrollFinish'], resolve),
    }
  ]
},
  {
    path: '/UserView',
    name: 'UserView',
    component:resolve => require(['@/view/user/UserView'], resolve),
    redirect: {name:'CourseList'},
    children: [
        //学分认定
      
        {
            path: 'education',
            name: 'education',
            component:resolve => require(['@/view/user/cognition/education'], resolve),
            
        },
        {
            path: 'inspect',
            name: 'inspect',
            component:resolve => require(['@/view/user/cognition/inspect'], resolve),
            
        },
        {
            path: 'creditList',
            name: 'creditList',
            component:resolve => require(['@/view/user/creditList'], resolve),
           
        },
        {
            path: 'creditrecognition',
            name: 'creditrecognition',
            component:resolve => require(['@/view/user/cognition/creditrecognition'], resolve),
            
        },
            //学分认定 end
      {
        path: 'HomeView',
        name: 'HomeView',
        component:resolve => require(['@/view/user/HomeView'], resolve),
      },
      // {
      //   path: 'UserMessage',
      //   name: 'UserMessage',
      //   component:resolve => require(['@/view/user/UserMessage'], resolve),
      // },
      {
        path: 'results',
        name: 'results',
        component:resolve => require(['@/view/user/results'], resolve),
        
    },
      {
        path: 'CourseList',
        name: 'CourseList',
        component:resolve => require(['@/view/user/CourseList'], resolve),
        meta: {
            keepAlive: true // 需要被缓存
        }
      },
      {
        path: 'YearCourse',
        name: 'YearCourse',
        component:resolve => require(['@/view/user/YearCourse'], resolve),
        meta: {
            keepAlive: true // 需要被缓存
        }
      },
      {
        path: '/CourseDetail/:id',
        name: 'CourseDetail',
        component:resolve => require(['@/view/user/CourseDetail'], resolve),
      },
      {
        path: '/Video/:id',
        name: 'Video',
        component:resolve => require(['@/view/user/Video'], resolve),
      },
      { 
        path: 'QuestionView',
        name: 'QuestionView',
        component:resolve => require(['@/view/user/QuestionView'], resolve),
      },
      {
        path: '/OnlineTest/:id',
        name: 'OnlineTest',
        component:resolve => require(['@/view/user/OnlineTest'], resolve),
      },
      {
        path: 'InvoiceView',
        name: 'InvoiceView',
        component:resolve => require(['@/view/user/InvoiceView'], resolve),
      },
      { 
        path: 'CreditInquiry',
        name: 'CreditInquiry',
        component:resolve => require(['@/view/user/CreditInquiry'], resolve),
      },
      {
          path: '/ResetPwd',
          name: 'ResetPwd',
          component:resolve => require(['@/view/user/ResetPwd'], resolve),
        }
    ]
  },
  {
    path: '/',
    name: 'Content',
    component:resolve => require(['@/view/content/Content'], resolve),
    redirect: {name:'Index'},
    children: [
      {
        path: 'Index',
        name: 'Index',
        component:resolve => require(['@/view/content/Index'], resolve),
      },
      
     
      {
        path: 'ImportantNotice',
        name: 'ImportantNotice',
        component:resolve => require(['@/view/content/ImportantNotice'], resolve),
      },
      {
        path: 'AboutUs',
        name: 'AboutUs',
        component:resolve => require(['@/view/content/AboutUs'], resolve),
      },
      {
        path: 'WVideo',
        name: 'WVideo',
        component:resolve => require(['@/view/content/WVideo'], resolve),
      }
    ]
  }
  ]
})
// export 



// WEBPACK FOOTER //
// ./src/router/index.js